import { Link } from "react-router-dom";
import { Seo, breadcrumbSchema } from "../components/site/Seo";
import { PageHero } from "../components/site/PageHero";
import { Reveal } from "../components/site/Reveal";
import { LocationSection } from "../components/site/Location";
import { CtaBand } from "../components/site/Cta";
import { SERVICES } from "../data/services";

export default function About() {
  const crumbs = [{ to: "/", label: "Accueil" }, { to: "/a-propos", label: "À propos" }];
  return (
    <>
      <Seo title="À propos | A+GLASS Pare-Brise HAGUENAU, centre A+ Glass à Haguenau" description="Découvrez A+GLASS Pare-Brise HAGUENAU, centre A+ Glass spécialiste pare-brise, vitrage et éclairage tous véhicules, 101A Route de Marienthal à Haguenau." path="/a-propos" schemas={[breadcrumbSchema(crumbs)]} />
      <PageHero eyebrow="À propos" title="A+ Glass Haguenau, votre centre de proximité" crumbs={crumbs} image="/images/facade-haguenau.webp" imageAlt="Façade du centre A+GLASS Pare-Brise HAGUENAU, 101A Route de Marienthal"
        intro="A+GLASS Pare-Brise HAGUENAU est un établissement de l'enseigne A+ Glass, spécialiste pare-brise, vitrage et éclairage pour tous types de véhicules." />
      <section className="px-5 py-20 lg:px-8">
        <div className="mx-auto grid max-w-[1320px] gap-12 lg:grid-cols-12">
          <Reveal className="space-y-5 text-lg leading-relaxed text-slate-700 lg:col-span-7">
            <h2 className="font-display text-3xl font-extrabold tracking-tight text-ag-ink">Notre centre</h2>
            <p>Installé au 101A Route de Marienthal à Haguenau, notre centre accueille les automobilistes de Haguenau et des communes voisines pour le remplacement de pare-brise, la réparation d'impact, le vitrage automobile, la calibration caméra / ADAS et la rénovation d'optiques.</p>
            <p>Nous sommes agréés par les assurances et vous accompagnons dans vos démarches. Selon disponibilité et conditions, un véhicule de prêt peut vous être proposé pendant l'intervention, et nous pouvons intervenir à domicile dans les secteurs desservis.</p>
            <div className="overflow-hidden rounded-[1.75rem] bg-ag-ink"><img src="/images/accueil-haguenau.webp" alt="Accueil et espace d'attente du centre A+ Glass Haguenau" loading="lazy" className="aspect-[4/3] w-full object-cover" width="1360" height="1020" /></div>
            <div className="rounded-2xl border-2 border-dashed border-ag-blue/30 bg-ag-mist p-6 text-base text-slate-600" data-testid="about-placeholder">
              <p className="font-semibold text-ag-ink">Contenu à compléter par l'établissement :</p>
              <ul className="mt-2 list-disc space-y-1 pl-5">
                <li>[Histoire du centre et date d'ouverture]</li>
                <li>[Présentation de l'équipe et des techniciens]</li>
                <li>[Photos de l'atelier et de l'équipe au travail]</li>
              </ul>
            </div>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5">
            <div className="rounded-[1.75rem] bg-ag-ink p-8 text-white">
              <h2 className="font-display text-2xl font-extrabold">Nos prestations</h2>
              <ul className="mt-5 divide-y divide-white/10">
                {SERVICES.map((s) => <li key={s.key}><Link to={s.path} className="block py-3 font-semibold hover:text-ag-yellow" data-testid={`about-service-${s.key}`}>{s.nav}</Link></li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </section>
      <LocationSection />
      <CtaBand />
    </>
  );
}
